export default __webpack_public_path__ + "a08727f63a54c41f4d7838b4acf0b80d.svg";